import Modal from 'react-modal';
import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { CartSummaryContent } from '@components/cart';
import { CloseIcon } from '@components/icons';
import { Subtitle2 } from '@components/styles/Typography';

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: '9',
        background: 'rgba(0, 0, 0, 0.2)',
        inset: 'unset',
    },
};

const MobileCartModal = ({
    isOpen,
    handleClose,
    subtotal,
    extras,
    discounts,
    modalContainerRef,
    cargoFee,
}) => {
    const { t } = useTranslation();
    return (
        <StyledModal
            style={customStyles}
            contentLabel="Cart Summary Modal"
            isOpen={isOpen}
            onRequestClose={handleClose}
            closeTimeoutMS={300}
            overlayClassName="cartSummaryModal"
        >
            <ModalContent
                isOpen={isOpen}
                className={isOpen ? 'slide-top' : 'slide-bottom'}
                ref={modalContainerRef}
            >
                <SummaryWrapper>
                    <Subtitle2 uppercase>{t('cartSummary')}</Subtitle2>
                    <CloseIcon onClick={handleClose} />
                </SummaryWrapper>

                <CartSummaryContent
                    color="bgGray50"
                    subtotal={subtotal}
                    extras={extras}
                    discounts={discounts}
                    cargoFee={cargoFee}
                />
            </ModalContent>
        </StyledModal>
    );
};
const StyledModal = styled(Modal)`
    position: fixed;
    bottom: 0;
    top: 0;
    right: 0;
    left: auto;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    border-radius: 25px 25px 0 0;
    flex-direction: column;
    justify-content: flex-end;
`;
const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    background: white;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    width: 100%;
    padding: 20px 20px 95px 20px;
`;
const SummaryWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    &:after {
        position: absolute;
        content: '';
        width: 84px;
        height: 1.5px;
        bottom: -5px;
        background: ${({ theme }) => theme.colors.primary};
    }
`;

export default MobileCartModal;
